import script from "./select-city.vue?vue&type=script&setup=true&lang=js"
export * from "./select-city.vue?vue&type=script&setup=true&lang=js"

import "./select-city.vue?vue&type=style&index=0&id=d8b8e830&lang=css"

const __exports__ = script;

export default __exports__